<div bsModal #createOrEditAsset="bs-modal" class="modal fade" (onShown)="onShown()" tabindex="-1" role="dialog"
     aria-labelledby="createOrEdit" aria-hidden="true" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">

      <div class="modal-header">
        <h4 class="modal-title">
          <span *ngIf="Asset.id && assign">{{ l("Assign Asset") }}</span>
          <span *ngIf="Asset.id && return">{{ l("Return Asset") }}</span>
        </h4>
        <button type="button" class="close" (click)="close()" aria-label="Close" [disabled]="saving">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <!-- Asset Basic Info -->
        <div class="row">
          <div class="col-md-2">
            <label for="AssetName">Asset Name</label>
          </div>
          <div class="col-md-4">
            <input type="text" id="AssetName" class="form-control"
                   [(ngModel)]="Asset.assetName" [disabled]="true" />
          </div>

          <div class="col-md-2">
            <label for="AssetType">Asset Type</label>
          </div>
          <div class="col-md-4">
            <p-dropdown [(ngModel)]="Asset.assetTypeId" [options]="AssetType" placeholder="Select Type"
                        [disabled]="true" inputStyleClass="form-control" styleClass="width-percent-100">
            </p-dropdown>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-2">
            <label for="AssetSerialNo">Asset Serial No</label>
          </div>
          <div class="col-md-4">
            <input type="text" id="AssetSerialNo" class="form-control"
                   [(ngModel)]="Asset.assetserialNo" [disabled]="true" />
          </div>

          <div class="col-md-2">
            <label for="Configuration">Configuration</label>
          </div>
          <div class="col-md-4">
            <input type="text" id="Configuration" class="form-control"
                   [(ngModel)]="Asset.confrtgartion" [disabled]="true" />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-2">
            <label for="AssetPrice">Asset Value</label>
          </div>
          <div class="col-md-4">
            <input type="text" id="AssetPrice" class="form-control"
                   [(ngModel)]="Asset.assetValue" [disabled]="true" />
          </div>

          <div class="col-md-2" *ngIf="!return">
            <label for="Remarks">Remarks</label>
          </div>
          <div class="col-md-4" *ngIf="!return">
            <textarea id="Remarks" class="form-control" rows="3"
                      [(ngModel)]="Asset.remarks" [disabled]="true"></textarea>
          </div>
        </div>

        <!-- Return Info (Only Date + Remarks) -->
        <div class="row mt-3" *ngIf="return">
          <div class="col-md-2">
            <label for="ReturnDate">Return Date</label>
          </div>
          <div class="col-md-4">
            <input type="text" id="ReturnDate" class="form-control"
                   [value]="returnAssignDate | date:'dd/MM/yyyy'" readonly />
          </div>
        </div>

        <div class="row mt-3" *ngIf="return">
          <div class="col-md-2">
            <label for="Remarks">Remarks</label>
          </div>
          <div class="col-md-4">
            <textarea id="Remarks" class="form-control" rows="3"
                      [(ngModel)]="Asset.remarks" readonly></textarea>
          </div>
        </div>

      </div>

      <div class="modal-footer">
        <button [disabled]="saving" type="button" class="btn btn-default" (click)="close()">
          {{ l("Cancel") }}
        </button>
        <button type="button" class="btn btn-primary blue" [buttonBusy]="saving"
                (click)="save()" [busyText]="l('SavingWithThreeDot')">
          <i class="fa fa-save"></i> <span>{{ l("Acknowledge") }}</span>
        </button>
      </div>

    </div>
  </div>
</div>
